<template>
  <div class="container-fluid footer-upper-container">
    <div class="row text-center">
      <div class="col-12">
        <ul class="list-horizontal">
          <li>
            <router-link :to="'/'+locale">{{$t("footer.home")}}</router-link>
          </li>
          <li>
            <router-link :to="'/'+locale+'/imprint'">{{$t("footer.imprint")}}</router-link>
          </li>
          <li>
            <router-link :to="'/'+locale+'/tos'">{{$t("footer.terms_and_conditions")}}</router-link>
          </li>
          <li>
            <router-link :to="'/'+locale+'/tos#cp'">{{$t("footer.cancellation_policy")}}</router-link>
          </li>
          <li>
            <router-link :to="'/'+locale+'/privacy'">{{$t("footer.privacy_policy")}}</router-link>
          </li>
          <li>
            <router-link :to="{name: 'versand'}" v-html="$t('footer.shipping_payment')"></router-link>
          </li>
        </ul>
      </div>
      <div class="col-md-6 mx-auto">
        <div class="footer-copyright" v-html="$t('footer.text')" />
      </div>
    </div>
  </div>
</template>

<script>
  import i18n from '../i18n';

export default {
  name: "Footer",
  data() {
    return {
      locale: i18n.locale,
    };
  },
};
</script>